import cn from 'classnames'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import MainButton from '../common/util/input/MainButton'
import { getBoostAction } from '../helpers/WaxApi'
import { PopupLoadingIndicator } from '../loadingindicator/PopupLoadingIndicator'
import ErrorMessage from './ErrorMessage'
import Popup from './Popup'

function StakeCpuNetPopup(props) {
    const balance = props['balance']
    const ual = props['ual'] ? props['ual'] : { activeUser: null }
    const activeUser = ual['activeUser']
    const callBack = props['callBack']
    const userName = activeUser ? activeUser['accountName'] : null
    const [isLoading, setIsLoading] = useState(false)
    const [stakeNet, setStakeNet] = useState(0)
    const [stakeCpu, setStakeCpu] = useState(0)
    const closeCallBack = props['closeCallBack']
    const [error, setError] = useState()

    const { t } = useTranslation('common')

    const stake = async () => {
        if ((!stakeNet && !stakeCpu) || stakeNet < 0 || stakeCpu < 0) {
            setError('Must at least stake a positive amount of CPU or NET')
            return false
        }
        const quantity_net = stakeNet ? stakeNet : 0
        const quantity_cpu = stakeCpu ? stakeCpu : 0
        setIsLoading(true)
        try {
            const result = await activeUser.signTransaction(
                {
                    actions: [
                        getBoostAction(activeUser),
                        {
                            account: 'eosio',
                            name: 'delegatebw',
                            authorization: [
                                {
                                    actor: userName,
                                    permission: activeUser['requestPermission'],
                                },
                            ],
                            data: {
                                from: userName,
                                receiver: userName,
                                stake_net_quantity: `${quantity_net.toFixed(
                                    8,
                                )} WAX`,
                                stake_cpu_quantity: `${quantity_cpu.toFixed(
                                    8,
                                )} WAX`,
                                transfer: false,
                            },
                        },
                    ],
                },
                {
                    expireSeconds: 300,
                    blocksBehind: 0,
                },
            )
            callBack({ wasStaked: true })
            closeCallBack()
        } catch (e) {
            console.log(e)
            setError(e.message)
        } finally {
            setIsLoading(false)
        }
    }

    const changeNet = (e) => {
        const val = e.target.value
        if (/^\d*\.?\d*$/.test(val)) {
            if (val === '') {
                setStakeNet(0)
            } else {
                const net = Math.min(parseFloat(val), balance)

                balanceCpu(net)

                setStakeNet(net)
            }
        }
    }

    const changeCpu = (e) => {
        const val = e.target.value
        if (/^\d*\.?\d*$/.test(val)) {
            if (val === '') {
                setStakeCpu(0)
            } else {
                const cpu = Math.min(parseFloat(val), balance)

                balanceNet(cpu)

                setStakeCpu(cpu)
            }
        }
    }

    const dismissError = () => {
        setError(null)
    }

    const cancel = () => {
        callBack({ wasStaked: false })
        closeCallBack()
    }

    const balanceNet = (cpu) => {
        if (stakeNet + cpu > balance)
            setStakeNet(Math.floor((balance - cpu) * 100000000) / 100000000)
    }

    const balanceCpu = (net) => {
        if (stakeCpu + net > balance)
            setStakeCpu(Math.floor((balance - net) * 100000000) / 100000000)
    }

    const applyStakeCpu = (percentage) => {
        const cpu = Math.floor(balance * percentage * 100000000) / 100000000

        balanceNet(cpu)

        setStakeCpu(cpu)
    }

    const applyStakeNet = (percentage) => {
        const net = Math.floor(balance * percentage * 100000000) / 100000000

        balanceCpu(net)

        setStakeNet(net)
    }

    const btnClass = cn('border border-primary p-1/2 m-1')

    return (
        <Popup title={'Stake CPU / NET'} cancel={cancel}>
            <div className="mx-auto text-xl font-bold mb-4">
                Unstaking {stakeCpu} WAX from CPU and {stakeNet} WAX from NET
            </div>
            <div className={cn('flex')}>
                <div className={'m-auto hover:underline cursor-pointer'}>
                    Available: {balance ? balance : 0} WAX
                </div>
                <div className={'mx-2'}>
                    <input
                        className={cn(
                            'border-b-2 border-primary bg-transparent color-primary',
                        )}
                        type="text"
                        placeholder={'CPU'}
                        onChange={changeCpu}
                        value={stakeCpu ? stakeCpu : ''}
                    />
                    <div className={'flex justify-evenly'}>
                        <MainButton
                            className={btnClass}
                            onClick={() => applyStakeCpu(0.1)}
                        >
                            10%
                        </MainButton>
                        <MainButton
                            className={btnClass}
                            onClick={() => applyStakeCpu(0.5)}
                        >
                            50%
                        </MainButton>
                        <MainButton
                            className={btnClass}
                            onClick={() => applyStakeCpu(0.9)}
                        >
                            90%
                        </MainButton>
                    </div>
                </div>
                <div className={'mx-2'}>
                    <input
                        className={cn(
                            'border-b-2 border-primary bg-transparent color-primary',
                        )}
                        type="text"
                        placeholder={'NET'}
                        onChange={changeNet}
                        value={stakeNet ? stakeNet : ''}
                    />
                    <div className={'flex justify-evenly'}>
                        <MainButton
                            className={btnClass}
                            onClick={() => applyStakeNet(0.1)}
                        >
                            10%
                        </MainButton>
                        <MainButton
                            className={btnClass}
                            onClick={() => applyStakeNet(0.5)}
                        >
                            50%
                        </MainButton>
                        <MainButton
                            className={btnClass}
                            onClick={() => applyStakeNet(0.9)}
                        >
                            90%
                        </MainButton>
                    </div>
                </div>
                <MainButton
                    className={'mt-0'}
                    onClick={stake}
                    disabled={!stakeNet && !stakeCpu}
                >
                    stake
                </MainButton>
                <MainButton
                    className={'mt-0 border-neutral text-neutral'}
                    onClick={cancel}
                >
                    Cancel
                </MainButton>
            </div>

            {error ? (
                <div onClick={dismissError}>
                    <ErrorMessage error={error} />
                </div>
            ) : (
                ''
            )}
            {isLoading ? (
                <PopupLoadingIndicator text={t('popups.loading_transaction')} />
            ) : (
                ''
            )}
        </Popup>
    )
}

export default StakeCpuNetPopup
